'use strict';

angular.module('web2print')
  .directive('scrollToTop', function () {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        scope.$watch(function () { return attrs.scrollToTop; }, function () {
          if (attrs.scrollToTop) {
            elem[0].scrollTop = 0;
          }
        });
      }
    };
  });
